export const JOBS = [
  {
    id: "1",
    title: "Nhân Viên Kỹ Thuật Chính Máy Lò Xo",
    company: "Công ty TNHH ManaBox Việt Nam",
    field: "Kỹ thuật",
    location: "Bắc Ninh",
    deadline: "25/12/2025",
    candidates: 25,
    newCandidates: 5,
    status: "active"
  },
  {
    id: "2",
    title: "Công nhân kỹ thuật (Vận hành - Bảo trì máy)",
    company: "CÔNG TY TNHH TOKIN ELECTRONICS (CƠ SỞ 1 - TP BẮC NINH)",
    field: "Kỹ thuật",
    location: "Bắc Ninh",
    deadline: "25/10/2024",
    candidates: 25,
    newCandidates: 0,
    status: "expired"
  },
  {
    id: "3",
    title: "Công nhân kỹ thuật (Vận hành - Bảo trì máy)",
    company: "CÔNG TY TNHH TOKIN ELECTRONICS (CƠ SỞ 1 - TP BẮC NINH)",
    field: "Kỹ thuật",
    location: "Bắc Ninh",
    deadline: "25/12/2025",
    candidates: 25,
    newCandidates: 5,
    status: "active"
  },
  {
    id: "4",
    title: "Công nhân kỹ thuật (Vận hành - Bảo trì máy)",
    company: "CÔNG TY TNHH TOKIN ELECTRONICS (CƠ SỞ 1 - TP BẮC NINH)",
    field: "Kỹ thuật",
    location: "Bắc Ninh",
    deadline: "25/12/2025",
    candidates: 25,
    newCandidates: 0,
    status: "active"
  },
  {
    id: "5",
    title: "Công nhân kỹ thuật (Vận hành - Bảo trì máy)",
    company: "CÔNG TY TNHH TOKIN ELECTRONICS (CƠ SỞ 1 - TP BẮC NINH)",
    field: "Kỹ thuật",
    location: "Bắc Ninh",
    deadline: "25/12/2025",
    candidates: 25,
    newCandidates: 5,
    status: "active"
  },
  {
    id: "6",
    title: "Công nhân kỹ thuật (Vận hành - Bảo trì máy)",
    company: "CÔNG TY TNHH TOKIN ELECTRONICS (CƠ SỞ 1 - TP BẮC NINH)",
    field: "Kỹ thuật",
    location: "Bắc Ninh",
    deadline: "25/12/2025",
    candidates: 25,
    newCandidates: 0,
    status: "active"
  },
  {
    id: "7",
    title: "Công nhân kỹ thuật (Vận hành - Bảo trì máy)",
    company: "CÔNG TY TNHH TOKIN ELECTRONICS (CƠ SỞ 1 - TP BẮC NINH)",
    field: "Kỹ thuật",
    location: "Bắc Ninh",
    deadline: "25/12/2025",
    candidates: 25,
    newCandidates: 0,
    status: "active"
  },
  {
    id: "8",
    title: "Công nhân kỹ thuật (Vận hành - Bảo trì máy)",
    company: "CÔNG TY TNHH TOKIN ELECTRONICS (CƠ SỞ 1 - TP BẮC NINH)",
    field: "Kỹ thuật",
    location: "Bắc Ninh",
    deadline: "25/12/2025",
    candidates: 25,
    newCandidates: 0,
    status: "active"
  },
  {
    id: "9",
    title: "Công nhân kỹ thuật (Vận hành - Bảo trì máy)",
    company: "CÔNG TY TNHH TOKIN ELECTRONICS (CƠ SỞ 1 - TP BẮC NINH)",
    field: "Kỹ thuật",
    location: "Bắc Ninh",
    deadline: "25/12/2025",
    candidates: 25,
    newCandidates: 0,
    status: "active"
  },
  {
    id: "10",
    title: "Công nhân kỹ thuật (Vận hành - Bảo trì máy)",
    company: "CÔNG TY TNHH TOKIN ELECTRONICS (CƠ SỞ 1 - TP BẮC NINH)",
    field: "Kỹ thuật",
    location: "Bắc Ninh",
    deadline: "25/12/2025",
    candidates: 25,
    newCandidates: 0,
    status: "active"
  }
];

export const ACCOUNTS = [
  { id: 1, name: "Nguyễn Văn A", email: "nguyenvana@example.com", role: "Admin", status: "Active" },
  { id: 2, name: "Trần Thị B", email: "tranthib@example.com", role: "User", status: "Active" },
  { id: 3, name: "Lê Văn C", email: "levanc@example.com", role: "User", status: "Inactive" },
];

export const CANDIDATES = [
  {
    id: 1,
    name: "Nguyễn Văn A",
    dob: "01/01/1990",
    phone: "037888999",
    email: "nguyenvana@gmail.com",
    jobId: "1",
    jobTitle: "Nhân Viên Kỹ Thuật Chính Máy Lò Xo",
    appliedDate: "25/12/2025",
    status: "New"
  },
  {
    id: 2,
    name: "Trần Thị B",
    dob: "15/05/1995",
    phone: "0987654321",
    email: "tranthib@gmail.com",
    jobId: "1",
    jobTitle: "Nhân Viên Kỹ Thuật Chính Máy Lò Xo",
    appliedDate: "24/12/2025",
    status: "Reviewed"
  },
  {
    id: 3,
    name: "Lê Văn C",
    dob: "20/10/1992",
    phone: "0912345678",
    email: "levanc@gmail.com",
    jobId: "2",
    jobTitle: "Công nhân kỹ thuật (Vận hành - Bảo trì máy)",
    appliedDate: "20/10/2024",
    status: "Rejected"
  },
];

export const TRAINING = [
  {
    id: "1",
    title: "THÔNG TIN VỀ QUYỀN VÀ CÁCH TIẾP CẬN CƠ CHẾ KHIẾU NẠI, TỐ CÁO...",
    image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80",
    description: "Nếu bạn là người lao động Việt Nam đang chuẩn bị làm việc tại Nhật Bản, việc nắm vững các quyền lợi...",
    content: `Nếu bạn là người lao động Việt Nam đang chuẩn bị làm việc tại Nhật Bản, việc nắm vững các quyền lợi và cơ chế bảo vệ pháp lý là vô cùng quan trọng. Một cuốn cẩm nang nhỏ mới được xuất bản vào tháng 8 năm 2025 sẽ cung cấp thông tin thiết yếu về các quyền, cách tiếp cận cơ chế khiếu nại, tố cáo và khắc phục hậu quả.
    
    ![Image](https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80)
    
    Nếu bạn là người lao động Việt Nam đang chuẩn bị làm việc tại Nhật Bản, việc nắm vững các quyền lợi và cơ chế bảo vệ pháp lý là vô cùng quan trọng. Một cuốn cẩm nang nhỏ mới được xuất bản vào tháng 8 năm 2025 sẽ cung cấp thông tin thiết yếu về các quyền, cách tiếp cận cơ chế khiếu nại, tố cáo và khắc phục hậu quả.`,
    createdAt: "23/10/2025",
    status: "Active"
  },
  {
    id: "2",
    title: "Khóa học kỹ năng mềm",
    image: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80",
    description: "Kỹ năng giao tiếp, làm việc nhóm...",
    content: "Nội dung khóa học kỹ năng mềm...",
    createdAt: "20/10/2025",
    status: "Active"
  },
  {
    id: "3",
    title: "Học tiếng Nhật N5",
    image: "https://images.unsplash.com/photo-1528164344705-47542687000d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80",
    description: "Khóa học tiếng Nhật cơ bản cho người mới bắt đầu...",
    content: "Nội dung khóa học tiếng Nhật...",
    createdAt: "15/10/2025",
    status: "Active"
  },
];

export const NEWS = [
  {
    id: "1",
    title: "THÔNG TIN VỀ QUYỀN VÀ CÁCH TIẾP CẬN CƠ CHẾ",
    image: "https://images.unsplash.com/photo-1504384308090-c54be3855833?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80",
    summary: "Nếu bạn là người lao động Việt Nam đang chuẩn bị làm việc tại Nhật Bản, việc nắm vững các quyền...",
    date: "14:52, Thứ năm, 23/10/2025",
    content: `Nếu bạn là người lao động Việt Nam đang chuẩn bị làm việc tại Nhật Bản, việc nắm vững các quyền lợi và cơ chế bảo vệ pháp lý là vô cùng quan trọng. Một cuốn cẩm nang nhỏ mới được xuất bản vào tháng 8 năm 2025 sẽ cung cấp thông tin thiết yếu về các quyền, cách tiếp cận cơ chế khiếu nại, tố cáo và khắc phục hậu quả.
    
    ![Image](https://images.unsplash.com/photo-1504384308090-c54be3855833?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80)
    
    Nội dung chi tiết về quyền lợi người lao động...`,
    author: "Admin",
    status: "Published"
  },
  {
    id: "2",
    title: "Hội thảo việc làm 2025",
    image: "https://images.unsplash.com/photo-1515187029135-18ee286d815b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80",
    summary: "Cơ hội việc làm cho sinh viên mới ra trường...",
    date: "09:00, Thứ hai, 15/01/2025",
    content: "Chi tiết về hội thảo việc làm...",
    author: "HR",
    status: "Published"
  },
  {
    id: "3",
    title: "Chính sách mới về bảo hiểm thất nghiệp",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80",
    summary: "Những thay đổi quan trọng cần biết...",
    date: "10:30, Thứ sáu, 20/02/2025",
    content: "Chi tiết về chính sách bảo hiểm thất nghiệp mới...",
    author: "Admin",
    status: "Published"
  },
  {
    id: "4",
    title: "Đào tạo kỹ năng mềm cho người lao động",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80",
    summary: "Khóa học miễn phí giúp nâng cao kỹ năng giao tiếp...",
    date: "14:00, Thứ tư, 05/03/2025",
    content: "Nội dung khóa học kỹ năng mềm...",
    author: "Training Dept",
    status: "Published"
  },
];
